import React, { useContext, useEffect, useState } from 'react'
import Card from '../../components/Card'
import { UserContext } from '../../contexts/UserContext';
import { ListeTransfertCashPickup,ListeTransfertBankAccount, ListeRecharge, Stats, ListeInvoice } from '../../helpers/api';
import Icon from '../../assets/icons/iconSetting.svg'
import IconTCash from "../../components/icons/iconTCash";
import IconTBancaire from "../../components/icons/iconTBancaire";
import IconRechargeBancaire from "../../components/icons/iconRechargeBancaire";
import Iconfacture from "../../components/icons/iconfacture";
import classNames from "classnames";
import Table from '../../components/table/table';
import Spinner from '../../components/Spinner';


const SecondHomeContainer = () => {

const [apiStats, setApiStats]=useState([])
const [tableData, setTableData] = useState([]);  const { user } = useContext(UserContext);
const [loadingData, setLoadingData] = useState(false);
const [typeService, setTypeService]= useState()
const [pageSize, setPageSize] = useState(10);
const [currentPage, setCurrentPage] = useState(1);
const [totalPage, setTotalPage] = useState(0);

const getStatusStyle = (status) => {
    switch (status?.toLowerCase()) {
      case "canceled":
        return "bg-[#A5A5A5]";
      case "complete":
        return "bg-[#0088FF]";
      case "in progress":
        return "bg-[#FF8D28]";
      default:
        return "bg-gray-100 text-gray-700 border-gray-200";
    }
  };

  const extractData = (response, type) => {
  switch (type) {
    case "recharges":
      return response.recharges;
    case "cash_pickup":
      return response.transfers;
    case "bank_account":
      return response.transfers;
    case "factures":
      return response.invoices;
    default:
      return [];
  }
};

const apiMap = {
  cash_pickup: ListeTransfertCashPickup,
  bank_account: ListeTransfertBankAccount,
  recharges: ListeRecharge,
  factures: ListeInvoice
};
const tabService = [
    {
     
      typeService: "cash_pickup",
      label: "R. Cash",
      icon: IconTCash,
      styleIcon: "stroke-[#5754E5]",
      color: "bg-[#5754E5]",
    },
    {
      
      typeService: "bank_account",
      label: "C. Compte",
      icon: IconTBancaire,
      styleIcon: "stroke-[#20C374]",
      color: "bg-[#20C374]",
    },
    {
     
      typeService: "recharges",
      label: "R. Mobile",
      icon: IconRechargeBancaire,
      styleIcon: "stroke-[#FFC000]",
      color: "bg-[#FFC000]",
    },
    {
     
      typeService: "factures",
      label: "P. Facture",
      icon: Iconfacture,
      styleIcon: "stroke-[#38C3FF]",
      color: "bg-[#38C3FF]",
    },
  ];

useEffect(()=>{
  const fetchData= async()=>{
    try{
      const response= await Stats(user?.accessToken)
      const formattedStats = [
  {
    value: response.nbrFirstTransferClients,
    icon: Icon,
    title: "Clients premier transfert",
  },
  {
    value: response.nbrPaidInvoices,
    icon: Icon,
    title: "Factures payées",
  },
  {
    value: response.nbrPaidRecharges,
    icon: Icon,
    title: "Recharges payées",
  },
  {
    value: response.nbrPaidTransfersBank,
    icon: Icon,
    title: "Transferts bancaires payés",
  },
  {
    value: response.nbrPaidTransfersCash,
    icon: Icon,
    title: "Transferts cash payés",
  },
  {
    value: response.nbrSimulationInvoices,
    icon: Icon,
    title: "Simulations factures",
  },
  {
    value: response.nbrSimulationRecharges,
    icon: Icon,
    title: "Simulations recharges",
  },
  {
    value: response.nbrSimulationTransfersBank,
    icon: Icon,
    title: "Simulations transferts bancaires",
  },
  {
    value: response.nbrSimulationTransfersCash,
    icon: Icon,
    title: "Simulations transferts cash",
  },
  {
    value: response.nbrUsersCreated,
    icon: Icon,
    title: "Utilisateurs créés",
  },
  {
    value: response.totalAmountRechargesPaid,
    icon: Icon,
    title: "Montant total recharges payées",
  },
  {
    value: response.totalAmountfacturesPaid,
    icon: Icon,
    title: "Montant total factures payées",
  },
  {
    value: response.totalAmounttransfersPaid,
    icon: Icon,
    title: "Montant total transferts payés",
  },
];
      setApiStats(formattedStats)
      
    }
    catch(error){

    }
  }
  if (user?.accessToken) fetchData();
},[user?.accessToken])

useEffect(()=>{
  const fetchData= async()=>{
     setLoadingData(true);
    try{
      const apiFunction = apiMap[typeService]
      if(!apiFunction) return
      const responseListe= await apiFunction(user?.accessToken)

      setTableData(extractData(responseListe, typeService))
       setPageSize(responseListe.limit)
      setCurrentPage(responseListe.page)
      setTotalPage(responseListe.total)
    
    } catch (error) {
      console.log(error);
    }finally{
       setLoadingData(false);
    }
  }
  if(user?.accessToken && typeService) fetchData()
},[typeService, user?.accessToken])


 const columns = [
    {
      label: "Référence",
      key: "Référence",
      customRenderers: (row) => <div>{row.order}</div>,
    },
    {
      label:'Nom du Client',
      key: "column2",
      customRenderers: (row) => (
        <div>
        {row.lastName} {row.firstName}
        </div>
      ),
    },
   
    {
      label:'email',
      key: "email",
      customRenderers: (row) => (
        <div>
          {row.email}
        </div>
      ),
    },
    {
      label:'Téléphone',
      key: "Téléphone",
      customRenderers: (row) => (
        <div>
          {row.phone}
        </div>
      ),
    },

     {
      label: "Status",
      key: "Status",
      customRenderers: (row) => (
        <div className="flex items-center bg-white rounded-[50px] max-w-min py-1 px-3 shadow-[0px_2px_10px_rgba(0,0,0,0.15)] gap-2  text-[10px]">
          <span
            className={`w-[8px] h-[8px] rounded-full ${getStatusStyle(
              row.status
            )}`}
          />
          {row.status}
        </div>
      ),
    },
  ];

  return (
      <div>

       {apiStats.length >0 
       ? <div className="flex flex-wrap gap-2 items-center">
        {apiStats.map((item, index)=>(
          <Card
            key={index}
            title={item.title}
            value={item.value}
            icon={item.icon}
          
          />
        ))}          
        </div>
      : <div className='flex items-center justify-center'><Spinner width="w-[50px]" height="h-[50px]" /></div>
    }
    <div className="flex flex-col bg-white border border-[#EEEEEE] p-4 rounded-[10px] w-full  gap-4 overflow-y-auto scroll mt-10 ">

         <div className='flex gap-2'>
        {tabService.map((tab, index) => {
                      const Icon = tab.icon;
                      return (
                        <button
                          key={index}
                          onClick={() => {
                            setTypeService(tab.typeService);
                          }}
                          className={classNames(
                            "rounded-[40px] pl-2 pr-3 gap-2 flex items-center h-[32px] shadow-[0px_2px_10px_rgba(0,0,0,0.15)] text-[#000] ",
                            typeService === tab.typeService
                              ? `border-[#5d55e8] text-[#FFF] ${
                                  typeService === tab.typeService && tab.color
                                }`
                              : " bg-white text-[#000] hover:bg-gray-50"
                          )}
                        >
                          <Icon
                            className={` ${
                              typeService === tab.typeService
                                ? "stroke-[#FFF]"
                                : tab.styleIcon
                            }`}
                          />
                          <span className="text-[12px]">{tab.label}</span>
                        </button>
                      );
                    })}
      </div>

          <Table
              setPageSize={setPageSize}
              pageSize={pageSize}
              currentPage={currentPage}
              totalPage={totalPage}
              setCurrentPage={setCurrentPage}
              data={tableData}
              message="Veuillez Sélectionner une action"
              columns={columns}
              loading={loadingData}
              excel={true}
              rowClassName={(row) => {
                const diff = (new Date(row.createdAt)) / 60000;
                return diff >= 5
                  ? " border-l-4 border-l-[#FF3B30]"
                  : "border-l-4  border-l-[#5754E5]";
              }}
            />

      </div>
     
    </div>
  )
}

export default SecondHomeContainer

